import React, { useEffect, useState } from 'react';

import { useKeyboard } from '@/contexts/KeyboardContext';

import './ButtonContainer.css';

interface ButtonContainerProps {
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  children: React.ReactNode;
  translucent?: boolean;
  animate?: boolean;
}

const ButtonContainer: React.FC<ButtonContainerProps> = ({
  position = 'fixed',
  children,
  translucent = true,
  animate = true
}) => {
  const [noSafeArea, setNoSafeArea] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const { keyboardWillShow, keyboardDidShow, keyboardDidHide } = useKeyboard();

  useEffect(() => {
    if (!animate) return;

    if (keyboardWillShow) {
      setIsHidden(true);
    }

    if (keyboardDidShow) {
      setNoSafeArea(true);
      setIsHidden(false);
      setIsAnimating(true);
    }

    if (keyboardDidHide) {
      setNoSafeArea(false);
      setIsAnimating(false);
    }
  }, [animate, keyboardWillShow, keyboardDidShow, keyboardDidHide]);

  return (
    <div
      className={`button-container ${translucent ? 'button-container--translucent' : ''} ${isAnimating ? 'button-container--animate' : ''} ${isHidden ? 'button-container--hidden' : ''} ${noSafeArea ? 'button-container--no-safe-area' : ''}`}
      style={{ position: position }}
    >
      {children}
    </div>
  );
};

export default ButtonContainer;
